import "./login.css";
import "react-toastify/dist/ReactToastify.css";

import axios from "axios";
import React, { Component } from "react";
import ReactDOM from "react-dom";
import { toast } from "react-toastify";
import { auth } from "shared/auth";
import { demoURls } from "shared/subDomainList.json";
import { getParams, getSubDomain } from "shared/util";
import {
  isContainWhiteSpace,
  isEmail,
  isEmpty,
  isLength
} from "shared/validator";

import {
  AWS_CONTACT_EXPORT_URL,
  AWS_CONTACT_IMPORT_URL,
  commonDemoLoginUrl,
  commonForgotPasswordUrl,
  commonLoginUrl,
  GOOGLE_SIGNIN_CLIENT_ID,
  HOSTNAME,
  oldAppBaseUrl,
  signupDomain,
  WEB_LOGIN
} from "../../config/appConfig";
import { customTrack } from "../Mixpanel/mixPanelFunctions";
import ShowNotification from "../Notification/LoadableShowNotification";
import WebexOnboardingPage from "../WebexOnboard/Loadable";
import { isAuthenticated } from "./auth";
import ForgotPassword from "./SubComponents/ForgotPassword/LoadableForgotPassword";
import LoginForm from "./SubComponents/LoginForm/LoadableLoginForm";
import SignupForm from "./SubComponents/SignupForm/LoadableSignupForm";
import SsoLoginForm from "./SubComponents/SsoLoginForm/LoadableSsoLoginForm";

const NODE_ENV = process.env.NODE_ENV;
var self = {};

class Login extends Component {
  constructor(props) {
    super(props);

    // abt means account blocked time
    let abt = JSON.parse(localStorage.getItem("abt"));
    abt = abt == null ? 0 : abt;
    const currentTime = new Date().getTime() / 1000;

    let isAccountBlocked;
    let accountBlockError;

    // 300 is in seconds
    if (currentTime - abt >= 300) {
      localStorage.removeItem("abt");
      isAccountBlocked = false;
      accountBlockError = false;
    } else {
      isAccountBlocked = true;
      accountBlockError = true;
    }

    this.state = {
      formData: {}, // Contains login form data
      forgotFormData: {}, // Contains forgot form data
      errors: {}, // Contains login field errors
      forgotFormerrors: {}, // Contains forgotform field errors
      formSubmitted: false, // Indicates submit status of login form
      forgotFormSubmitted: false, // Indicates submit status of login form
      signupFormSubmitted: false, // Indicates submit status of signup form
      loading: false, // Indicates in progress state of login form
      isLoading: false,
      isLoggedInCheck: false,
      isSignup: false,
      loginError: false,
      emailError: false,
      forgotError: false,
      signupError: false,
      forgotSuccess: false,
      showLoginForm: true,
      showSsoLoginForm: false,
      showSignupForm: false,
      showLoginButton: false,
      showNextButton: true,
      appURLs: {},
      onboardingPage: false,
      rememberMe: true,
      showForgotForm: false,
      downLoadError: false,
      loginStore: {},
      isMsTeamsLogin: false,
      isSsoExist: true,
      socialLoginEmailNotFound: false,
      isCheckingSSO: false,
      accountBlockError: accountBlockError,
      isAccountBlocked: isAccountBlocked,
      loadTime: abt,
      timeElapsed: currentTime - abt
    };
  }

  UNSAFE_componentWillMount() {
    // check if user limit error exists
    const queryString = window.location.search;
    const queryParams = new URLSearchParams(queryString);

    let msTeamsUrl = queryParams.get("platform");
    let isMsTeamsLogin = false;
    if (msTeamsUrl === "msteams") {
      isMsTeamsLogin = true;
    }

    let autheticated = isAuthenticated();

    if (autheticated) {
      // if MSTeams login
      if (msTeamsUrl === "msteams") {
        this.windowClose();
      }

      const base_url = window.location.origin;
      window.location.href = base_url + "/home";
    } else {
      this.setState({ isLoggedInCheck: true, isMsTeamsLogin: isMsTeamsLogin });
    }

    // check if user limit error exists
    if (queryParams.get("limitError") === "usersLimit") {
      // show users limit exceeds
      this.setState({ usersLimitError: true });
    }

    self = this;
    const sub_domain = getSubDomain(window.location.hostname);

    this.checkSSOIdentity(sub_domain);
    // this.checkSSOExists(sub_domain);

    if (demoURls.includes(sub_domain)) {
      this.setState({ loading: true }, () => {
        this.demoLogin({ sub_domain });
      });
    }

    let params = getParams(window.location.href);

    if (params.error) {
      this.setState({ loginError: params.error });
    }
  }

  componentDidMount() {
    setTimeout(() => {
      localStorage.removeItem("abt");
      this.setState({
        isAccountBlocked: false,
        accountBlockError: false
      });
      // 300000 is in milliseconds
    }, 300000 - this.state.timeElapsed * 1000);

    if (
      window.location.href.includes("redirect") &&
      window.location.href.includes("/webex/surveys/list")
    ) {
      this.setState({
        showLoginForm: false,
        showForgotForm: false,
        forgotSuccess: false,
        showSignupForm: false,
        onboardingPage: true
      });
    }

    if (window.location.search.includes("form=signup")) {
      this.setState({
        showLoginForm: false,
        showForgotForm: false,
        forgotSuccess: false,
        showSignupForm: true,
        onboardingPage: false
      });
    }

    if (
      window.location.href.includes("redirect") &&
      window.location.href.includes("login") &&
      window.location.href.includes("/webex/surveys/list") &&
      window.localStorage.getItem("webexInstalled") !== "true"
    ) {
      const uniqueKey = "def" + Date.now().toString();
      window.localStorage.setItem("defaultId", uniqueKey);
      this._initMixpanel("Webex Installed");
      window.localStorage.setItem("webexInstalled", true);
    }
  }

  windowClose = () => {
    window.open("", "_parent", "");
    window.close();
  };

  _initMixpanel = val => {
    customTrack(
      val,
      {
        $defaultId: window.localStorage.getItem("defaultId")
      },
      true
    );
  };

  /** check server identity for sso */
  checkSSOIdentity = sub_domain => {
    let preExistingSubDomain = [
      "web",
      "stgfrontend",
      "multiregion-stgfrontend",
      "demo",
      "platform",
      "localhost",
      "admin",
      "us1",
      "zonka",
      "classic"
    ];
    const queryString = window.location.search;
    const queryParams = new URLSearchParams(queryString);

    let isAllowSSO = true;
    let siteName = sub_domain;
    //check if domain is existing domains
    if (preExistingSubDomain.indexOf(sub_domain) !== -1) {
      isAllowSSO = false;
      siteName = "";
    }

    if (!isAllowSSO && !queryParams.get("email")) {
      return true;
    }

    let payload = {
      email: queryParams.get("email") || "",
      siteName: siteName ? siteName : ""
    };

    this.setState({ formData: payload }, () => {
      this.reqIdentifyRegion();
    });
  };

  checkSSOExists = (sub_domain, inputEmail) => {
    let preExistingSubDomain = [
      "web",
      "stgfrontend",
      "multiregion-stgfrontend",
      "demo",
      "platform",
      "localhost",
      "admin",
      "us1",
      "zonka",
      "classic"
    ];
    const queryString = window.location.search;
    const queryParams = new URLSearchParams(queryString);

    let isAllowSSO = true;
    let siteName = sub_domain;
    //check if domain is existing domains
    if (preExistingSubDomain.indexOf(sub_domain) !== -1) {
      isAllowSSO = false;
      siteName = "";
    }

    if (!isAllowSSO && !queryParams.get("email") && !inputEmail) {
      return true;
    }

    let payload = {
      email: inputEmail || "", //queryParams.get("email") || "",
      siteName: siteName ? siteName : ""
    };

    axios
      .post(`${this.state.appURLs.API_URL}/api/v1/sso-exists`, payload)
      .then(response => {
        if (response.status === 200) {
          if (response.data.err === "sitenameNotFound") {
            // redirect here
            window.location = WEB_LOGIN;
          } else {
            if (
              response.data.data &&
              Object.keys(response.data.data).length &&
              response.data.data.sso
            ) {
              this.setState({
                loginStore: response.data.data,
                showSsoLoginForm: false,
                showLoginForm: true
              });
            } else {
              this.setState({
                showLoginButton: false,
                showNextButton: true,
                isSsoExist: false
              });
            }
          }
        } else {
          // throw "Not logedin";
          throw new Error("Not logedin");
        }
      })
      .catch(error => {
        this.setState({ loading: false });
      });
  };

  ssoLogin = () => {
    let { _id, sso } = this.state.loginStore;

    // let payload = {
    //   id: _id,
    //   name: sso,
    // };

    let appURLsStr = localStorage.getItem("appURLs");

    let API_URL = commonLoginUrl;

    if (appURLsStr) {
      let appURLsObj = JSON.parse(appURLsStr);

      API_URL =
        appURLsObj && appURLsObj.API_URL ? appURLsObj.API_URL : commonLoginUrl;
    }

    window.location = API_URL + "/api/v1/sso/login?id=" + _id + "&sso=" + sso;
  };

  // Login to demo User
  demoLogin = ({ sub_domain }) => {
    const base_url = window.location.origin;
    axios
      .post(commonDemoLoginUrl, { sub_domain })
      .then(response => {
        if (response.status === 200) {
          auth.setToken("true", true, true);
          auth.setUserInfo(response.data.data.user, true, true);
          window.location.href = base_url + "/home";
        } else {
          // throw "Not logedin";
          throw new Error("Not logedin");
        }
      })
      .catch(error => {
        this.setState({ loading: false });
      });
  };

  handleCheck = () => {
    this.setState({ rememberMe: !this.state.rememberMe });
  };

  handleChangeEmail = () => {
    this.setState(
      {
        showNextButton: !this.state.showNextButton,
        showLoginButton: !this.state.showLoginButton
      },
      () => {
        if (document.getElementById("email")) {
          document.getElementById("email").focus();
        }
      }
    );
  };

  /**
   * Handle login form changes
   */
  handleInputChange = event => {
    const target = event.target;
    const value = target.value;
    const name = target.name;
    let { formData } = this.state;

    if (name === "txtEmail") {
      formData["email"] = value;
    } else if (name === "txtPassword") {
      formData["password"] = value;
    } else {
      formData[name] = value;
    }

    let errors = this.validateLoginForm(formData, [`${name}`]);
    this.setState({ formData, errors });
  };

  /**
   * Handle Signup form changes
   */
  handleSignupForm = event => {
    const target = event.target;
    const value = target.value;
    const name = target.name;
    let { formData } = this.state;

    if (name === "txtSignupEmail") {
      formData["email"] = value;
    } else if (name === "txtSignupPassword") {
      formData["password"] = value;
    } else if (name === "txtFullName") {
      formData["fullName"] = value;
    } else if (name === "txtCompanyName") {
      formData["companyName"] = value;
    } else if (name === "txtCompanyRegion") {
      formData["region"] = value;
    } else {
      formData[name] = value;
    }

    if (!formData["region"]) {
      formData["region"] = "US";
    }

    let errors = this.validateSignupForm(formData, [`${name}`]);
    this.setState({ formData, errors });
  };

  /**
   * Handle forgot form changes
   */
  handleForgotInputChange = event => {
    const target = event.target;
    const value = target.value;
    const name = target.name;

    let { forgotFormData } = this.state;
    forgotFormData[name] = value;

    this.setState({
      forgotFormData: forgotFormData
    });
  };

  handleNextButton = val => {
    let errors = {};
    this.validateEmailField(errors, this.state.formData, ["txtEmail"]);

    if (isEmpty(errors)) {
      this.reqIdentifyRegion();
    } else {
      this.setState({ formData: this.state.formData, errors });
    }
  };

  validateEmailField = (errors, formData, field) => {
    if (
      (field.includes("txtEmail") || !field.length) &&
      isEmpty(formData.email)
    ) {
      errors.email = "Please enter  your email address";
    } else if (field.includes("txtEmail") && !isEmail(formData.email)) {
      errors.email = "Please enter a valid email address";
    }

    return errors;
  };

  validatePasswordField = (errors, formData, field) => {
    if (
      (field.includes("txtPassword") || !field.length) &&
      isEmpty(formData.password)
    ) {
      errors.password = "Please enter your password";
    } else if (
      field.includes("txtPassword") &&
      isContainWhiteSpace(formData.password)
    ) {
      errors.password = "Password should not contain white spaces";
    } else if (
      field.includes("txtPassword") &&
      !isLength(formData.password, { gte: 6, lte: 16, trim: true })
    ) {
      errors.password = "Password should be between 6 to 16 characters long";
    }

    return errors;
  };

  /**
   * Validate login form
   */
  validateLoginForm = (formData, field = []) => {
    let errors = {};
    // const { formData } = this.state;

    this.validateEmailField(errors, formData, field);
    this.validatePasswordField(errors, formData, field);

    if (isEmpty(errors)) {
      return true;
    } else {
      return errors;
    }
  };

  /**
   * Validate Signup form
   */
  validateSignupForm = (formData, field = []) => {
    let errors = {};

    if ((field.includes("email") || !field.length) && isEmpty(formData.email)) {
      errors.signupEmail = "Please enter your email address";
    } else if (field.includes("email") && !isEmail(formData.email)) {
      errors.signupEmail = "Please enter a valid email address";
    }

    if (
      (field.includes("fullName") || !field.length) &&
      isEmpty(formData.fullName)
    ) {
      errors.fullName = "Please enter your full name";
    } else if (
      field.includes("fullName") &&
      !formData.fullName.match(/^[A-Z][a-zA-Z]{1,}(?: [A-Z][a-zA-Z]*){0,2}$/)
    ) {
      errors.fullName = "Please enter your full name";
    }

    if (
      (field.includes("companyName") || !field.length) &&
      isEmpty(formData.companyName)
    ) {
      errors.companyName = "Please enter your company name";
    }

    if (
      (field.includes("password") || !field.length) &&
      isEmpty(formData.password)
    ) {
      errors.signupPassword = "Please enter your password";
    } else if (
      field.includes("password") &&
      isContainWhiteSpace(formData.password)
    ) {
      errors.signupPassword = "Password should not contain white spaces";
    } else if (
      field.includes("password") &&
      !isLength(formData.password, { gte: 6, lte: 16, trim: true })
    ) {
      errors.signupPassword =
        "Password should be between 6 to 16 characters long";
    }

    if (
      (field.includes("region") || !field.length) &&
      isEmpty(formData.region)
    ) {
      errors.region = "Please Select Data Center";
    }

    if (isEmpty(errors)) {
      return true;
    } else {
      return errors;
    }
  };

  /**
   * Validate forgot form
   */
  validateForgotForm = e => {
    let forgotFormerrors = {};
    const { forgotFormData } = this.state;

    if (isEmpty(forgotFormData.email)) {
      forgotFormerrors.email = "Please enter your email address";
    } else if (!isEmail(forgotFormData.email)) {
      forgotFormerrors.email = "Please enter a valid email address";
    }

    if (isEmpty(forgotFormerrors)) {
      return true;
    } else {
      return forgotFormerrors;
    }
  };

  /** social login */
  onSocialLogin = res => {
    var payload = {
      email: res.email,
      password: res.id_token,
      social: res.social,
      name: res.name
    };

    if (res.authData) {
      payload["authData"] = res.authData;
    }

    this.setState(
      {
        formData: payload
      },
      () => this.reqIdentifyRegion("social")
    );
  };

  // social signup
  onSocialSignup = res => {
    var payload = {
      email: res.email,
      password: res.id_token,
      social: res.social,
      name: res.name
    };

    if (res.authData) {
      payload["authData"] = res.authData;
    }

    this.setState({ formData: payload }, () => {
      this.reqSignupApi();
    });
  };

  /** login form submit */
  login = e => {
    e.preventDefault();
    const { showNextButton, showLoginButton } = this.state;

    if (showNextButton === true && showLoginButton === false) {
      this.handleNextButton();
    } else {
      let errors =
        this.state.errors ||
        isEmpty(this.state.errors) ||
        Object.entries(this.state.formData).length !== 2
          ? this.validateLoginForm(this.state.formData)
          : this.state.errors;

      if (errors === true) {
        this.setState({
          isLoading: true
        });
        this.reqLoginApi();
      } else {
        this.setState({
          errors: errors,
          formSubmitted: true
        });
      }
    }
  };

  /** login form submit */
  signup = e => {
    e.preventDefault();

    let errors =
      this.state.errors ||
      isEmpty(this.state.errors) ||
      Object.entries(this.state.formData).length !== 2
        ? this.validateSignupForm(this.state.formData)
        : this.state.errors;

    if (errors === true) {
      this.reqSignupApi();
    } else {
      this.setState({
        errors: errors,
        signupFormSubmitted: true
      });
    }
  };

  /** login form submit */
  forgotpassword = e => {
    e.preventDefault();

    let forgotFormerrors = this.validateForgotForm();

    if (forgotFormerrors === true) {
      this.reqForgotpasswordApi();
    } else {
      this.setState({
        forgotFormerrors: forgotFormerrors,
        forgotFormSubmitted: true
      });
    }
  };

  /**
   * Show login error
   */
  showLoginError = () => {
    this.setState(
      {
        loginError: true
      },
      () => {
        setTimeout(this.closeLoginError, 3000);
      }
    );
  };

  /**
   * Show email error
   */
  showEmailError = () => {
    this.setState(
      {
        emailError: true
      },
      () => {
        setTimeout(this.closeEmailError, 3000);
      }
    );
  };

  /**
   * Show account block error
   */
  showAccountBlockError = () => {
    this.setState({ accountBlockError: true });
  };

  /**
   * Show login error
   */
  showForgotError = () => {
    this.setState(
      {
        forgotError: true
      },
      () => {
        setTimeout(this.closeForgotError, 3000);
      }
    );
  };

  /**
   * Show Signup error
   */
  showSignupError = msg => {
    const message = msg
      ? msg
      : "Email address already exists. Please try again.";
    this.setState(
      {
        signupError: true
      },
      () => {
        toast.dark(() => message, {
          position: "bottom-center",
          autoClose: 3000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined
        });
      }
    );
  };

  closeLoginError = () => {
    this.setState({ loginError: false, usersLimitError: false });
  };
  closeSocialLoginEmailNotFoundError = () => {
    this.setState({
      loginError: false,
      usersLimitError: false,
      socialLoginEmailNotFound: false
    });
  };

  closeEmailError = () => {
    this.setState({ emailError: false });
  };

  closeSsoError = () => {
    this.setState({ isSsoExist: true });
  };

  closeDownloadError = () => {
    this.setState({ downLoadError: false });
  };

  closeForgotError = () => {
    this.setState({ forgotError: false });
  };

  closeSignupError = () => {
    this.setState({ signupError: false });
  };

  /**
   * Show hide form
   */
  showForm = formName => {
    if (formName === "forgotpassword") {
      this.setState({
        showLoginForm: false,
        showSsoLoginForm: false,
        showForgotForm: true,
        forgotSuccess: false,
        showSignupForm: false,
        onboardingPage: false
      });
    } else if (formName === "login") {
      this.setState({
        showLoginForm: true,
        showSsoLoginForm: false,
        showForgotForm: false,
        forgotSuccess: false,
        showSignupForm: false,
        onboardingPage: false,
        showNextButton: true,
        showLoginButton: false,
        loginStore: {},
        formData: {}
      });
    } else if (formName === "ssoLogin") {
      this.setState({
        showLoginForm: false,
        showSsoLoginForm: true,
        showForgotForm: false,
        forgotSuccess: false,
        showSignupForm: false,
        onboardingPage: false,
        showNextButton: true,
        showLoginButton: false,
        loginStore: {},
        formData: {}
      });
    } else if (formName === "signup") {
      this.setState({
        showLoginForm: false,
        showSsoLoginForm: false,
        showForgotForm: false,
        forgotSuccess: false,
        showSignupForm: true,
        onboardingPage: false
      });
    } else {
      this.setState({
        showLoginForm: true,
        showSsoLoginForm: false,
        showForgotForm: false,
        forgotSuccess: false,
        showSignupForm: false,
        onboardingPage: false
      });
    }
  };

  readCookie = cname => {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(";");
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) === " ") {
        c = c.substring(1);
      }
      if (c.indexOf(name) === 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  };
  /**
   * write cookie method
   */
  writeCookie = (cname, cvalue, days) => {
    // const domain = "domain=" + document.domain.match(/[^\.]*\.[^.]*$/)[0] + ";";

    let matchDomain = document.domain.match(/[^\.]*\.[^.]*$/);

    if (matchDomain) {
      matchDomain =
        matchDomain[0] !== undefined ? matchDomain[0] : document.domain;
    } else {
      matchDomain = document.domain;
    }

    const domain = "domain=" + matchDomain + ";";

    var dt, expires;
    dt = new Date();
    dt.setTime(dt.getTime() + days * 24 * 60 * 60 * 1000);
    expires = "; Secure; expires=" + dt.toGMTString();
    document.cookie = cname + "=" + cvalue + expires + "; path=/; " + domain;
  };

  checkIdsExist = async data => {
    const isURLexists = await axios.post(
      `${commonLoginUrl}urlvalidation`,
      data
    );
    return { ...isURLexists.data };
  };

  /**
   * Send request in ms teams login
   * @param {*} token
   */
  reqMsTeamsApi = async token => {
    try {
      const queryString = window.location.search;
      const queryParams = new URLSearchParams(queryString);

      let msTeamsUrl = queryParams.get("platform");
      if (msTeamsUrl === "msteams") {
        const response = await axios.get(
          `${commonLoginUrl}teams/connect` + queryString,
          {
            headers: {
              "x-access-token": token
            }
          }
        );

        if (response.status === 200) {
          this.windowClose();
        }
      }
    } catch (error) {
      console.log("reqMsTeamsApi Error:", error);
    }
  };

  reqIdentifyRegion = async type => {
    const payload = { ...this.state.formData };
    this.setState({
      isLoading: true
    });

    await axios
      .post(`${commonLoginUrl}identify`, payload)
      .then(response => {
        this.setState({
          isLoading: false
        });

        if (
          response.data.status === 200 ||
          response.data.response === "success"
        ) {
          localStorage.setItem(
            "appURLs",
            JSON.stringify(response.data.data.app_urls)
          );

          if (type !== undefined && type === "social") {
            this.setState(
              {
                appURLs: response.data.data.app_urls
                // showLoginButton: !this.state.showSsoLoginForm ? true :false,
                // showNextButton: !this.state.showSsoLoginForm ? false :true
              },
              () => {
                this.reqLoginApi();
              }
            );
          } else {
            this.setState(
              {
                appURLs: response.data.data.app_urls,
                showLoginButton: true,
                showNextButton: false
              },
              () => {
                // call check iso login setting
                const sub_domain = getSubDomain(window.location.hostname);
                const email = payload.email ? payload.email : "";
                // check SSO login
                if (this.state.showSsoLoginForm) {
                  this.checkSSOExists(sub_domain, email);
                }
              }
            );
          }
        }
      })
      .catch(function(error) {
        self.setState({
          isLoading: false
        });

        if (error.response) {
          console.log("Error", error, error.response);
          self.showEmailError();
        }
      });
  };

  reqLoginApi = async () => {
    const { formData, isMsTeamsLogin } = this.state;
    const sub_domain = getSubDomain(window.location.hostname);
    let siteName = sub_domain;
    let preExistingSubDomain = [
      "web",
      "stgfrontend",
      "multiregion-stgfrontend",
      "demo",
      "platform",
      "localhost",
      "admin"
    ];

    if (preExistingSubDomain.indexOf(sub_domain) !== -1) {
      siteName = "";
    }

    formData.sitename = siteName;
    formData.screenResolution =
      window.screen.width + "x" + window.screen.height;
    var payload = { ...formData };

    // XMLHttpRequest from a different domain cannot set cookie values for their own
    // domain unless withCredentials is set to true before making the request.
    try {
      const response = await axios.post(
        `${this.state.appURLs.API_URL}/api/v1/login`,
        payload,
        { withCredentials: true }
      );

      this.setState({
        isLoading: false
      });

      if (response.status === 200) {
        if (
          response.data.data &&
          response.data.data.system &&
          response.data.data.system === "old"
        ) {
          // self.writeCookie("customer_system", "old", 365);

          // if social login
          if (payload.social === "google") {
            window.location =
              "https://accounts.google.com/o/oauth2/v2/auth?scope=email+profile&response_type=code&client_id=" +
              GOOGLE_SIGNIN_CLIENT_ID +
              "&redirect_uri=" +
              oldAppBaseUrl +
              "/branch/socialConnection";
          }

          // submit form
          document.getElementById("login-form").action =
            oldAppBaseUrl + "/branch/authenticate";
          document.getElementById("login-form").submit();
        } else {
          // set token and user information
          // self.writeCookie("customer_system", "new", 365);
          let userId = response.data.data.user._id;
          let remember = self.state.rememberMe;
          self.writeCookie("user_id", userId, 365);
          auth.setToken("true", true, remember);
          auth.setUserInfo(response.data.data.user, true, remember);

          // call ms teams success login api
          if (isMsTeamsLogin) {
            this.reqMsTeamsApi(response.data.data.token);
            return true;
          }

          // Integration redirects starts from here
          let paramsForCode = new URLSearchParams(window.location.search);

          if (
            paramsForCode.get("redirect") &&
            (paramsForCode.get("redirect").includes("hubspot") ||
              paramsForCode.get("redirect").includes("zoom"))
          ) {
            // check if redirect is for our domain
            if (paramsForCode.get("redirect").includes(HOSTNAME)) {
              window.location = `${paramsForCode.get("redirect")}`;
            } else {
              window.location = `${window.location.origin}/home`;
            }

            return;
          } else if (
            paramsForCode.get("code") &&
            paramsForCode.get("redirect").includes("pipedrive")
          ) {
            // check if redirect is for our domain
            if (paramsForCode.get("redirect").includes(HOSTNAME)) {
              window.location = `${paramsForCode.get(
                "redirect"
              )}&code=${paramsForCode.get("code")}`;
            } else {
              window.location = `${window.location.origin}/home`;
            }

            return;
          } else if (
            paramsForCode.get("shop") &&
            paramsForCode.get("redirect")
          ) {
            // check if redirect is for our domain
            if (paramsForCode.get("redirect").includes(HOSTNAME)) {
              window.location = `${paramsForCode.get(
                "redirect"
              )}&shop=${paramsForCode.get("shop")}`;
            } else {
              window.location = `${window.location.origin}/home`;
            }

            return;
          }
          // Integration redirects ends here

          if (
            window.location.search &&
            window.location.search.indexOf("?error=true") === -1 &&
            window.location.search.indexOf("?type=MS") === -1 &&
            window.location.search.indexOf("?email=") === -1
          ) {
            let params = getParams(window.location.href);

            if (
              params &&
              params.hasOwnProperty("redirect") &&
              params["redirect"]
            ) {
              const URLParams = new URL(params["redirect"]);
              const redirParams = URLParams.pathname.split("/");

              // const redirParams = getURLParams(
              //   params["redirect"],
              //   "pathname"
              // ).split("/");

              if (
                (redirParams[1] === "responseinbox" ||
                  redirParams[1] === "contacts" ||
                  redirParams[1] === "surveys" ||
                  redirParams[1] === "devices") &&
                redirParams.length > 2
              ) {
                const isExist = await this.checkIdsExist({
                  type: redirParams[1],
                  _id: redirParams[2],
                  companyId: response.data.data.user.companyId._id
                });

                if (isExist["success"]) {
                  // check if redirect is for our domain
                  if (params["redirect"].includes(HOSTNAME)) {
                    window.location = params["redirect"];
                  } else {
                    window.location = `${window.location.origin}/home`;
                  }
                } else {
                  window.location = `${window.location.origin}/home`;
                }
              } else {
                // check if redirect is for our domain
                if (params["redirect"].includes(HOSTNAME)) {
                  window.location = params["redirect"];
                } else {
                  window.location = `${window.location.origin}/home`;
                }
              }
            } else {
              const queryString = window.location.search;
              const urlParams = new URLSearchParams(queryString);

              urlParams.get("secret") === userId
                ? this.setState({ downLoadError: false })
                : this.setState({ downLoadError: true });
              if (
                urlParams.get("type") === "contacts" &&
                urlParams.get("fileId") &&
                urlParams.get("secret") === userId
              ) {
                let finalUrl = `${AWS_CONTACT_EXPORT_URL}/Contacts_Export_${urlParams.get(
                  "fileId"
                )}.csv`;
                window.location.href = finalUrl;
              } else if (
                urlParams.get("type") === "contacts_import" &&
                urlParams.get("fileId") &&
                urlParams.get("secret") === userId
              ) {
                let finalUrl = `${AWS_CONTACT_IMPORT_URL}/Contacts_Import_${urlParams.get(
                  "fileId"
                )}.csv`;
                window.location.href = finalUrl;
              } else if (
                urlParams.get("type") === "report" &&
                urlParams.get("fileId") &&
                urlParams.get("secret") === userId
              ) {
                let finalUrl = `${AWS_CONTACT_IMPORT_URL}/reportPdf/${urlParams.get(
                  "fileId"
                )}`;
                window.location.href = finalUrl;
              }
            }
          } else {
            if (NODE_ENV !== "development") {
              if (response.data.data.user.companyId.isOnboardingCompleted) {
                window.location = window.location.origin + "/home";
              } else {
                window.location = window.location.origin + "/create-experience";
              }
              return;
            }

            window.location = window.location.origin + "/home";
          }
        }
      } else if (response.data.status === 401) {
        this.setState({
          loginError: true,
          showLoginButton: false,
          showNextButton: true
        });
      } else {
        this.setState({
          showLoginButton: false,
          showNextButton: true
        });
      }
    } catch (error) {
      if (
        payload &&
        payload.social &&
        ["google", "microsoft"].includes(payload.social) &&
        error &&
        error.response &&
        error.response.status !== 200
      ) {
        this.setState({ socialLoginEmailNotFound: true });
      }

      this.setState({
        isLoading: false
      });

      if (
        error.response &&
        error.response.data &&
        error.response.data.status &&
        error.response.data.status == 403
      ) {
        localStorage.setItem(
          "abt",
          JSON.stringify(new Date().getTime() / 1000)
        ); // convert milliseconds to seconds.

        this.setState({
          isAccountBlocked: true,
          accountBlockError: true
        });

        setTimeout(() => {
          localStorage.removeItem("abt");
          this.setState({
            isAccountBlocked: false
          });
        }, 300000);
      } else {
        window.location.href.includes("secret")
          ? this.setState({ downLoadError: true })
          : this.showLoginError();
      }
    }
  };

  reqSignupApi = async () => {
    const { formData } = this.state;

    if (window.location.host !== "platform.zonkafeedback.com") {
      formData.zonkaDebugFlag = true;
    }

    if (window.location.search.includes("webex")) {
      formData.edition = "webex";
      formData.defaultId = window.localStorage.getItem("defaultId");
    }

    if (window.location.search.includes("app/intercom")) {
      formData.referrer = "Intercom";
      formData.referrerPath = "https://www.intercom.com/app-store";
    }

    if (formData.region === undefined) {
      formData.region = "US";
    }

    formData.mobile = "";
    const payload = { ...formData };

    this.setState({
      isSignup: true
    });

    const signupURL =
      NODE_ENV === "nightly"
        ? signupDomain
        : NODE_ENV == "stage"
        ? formData["region"].toLowerCase() == "eu"
          ? `https://${formData["region"].toLowerCase()}-${signupDomain}`
          : `https://${signupDomain}`
        : formData["region"].toLowerCase() == "eu" //eu(europe) condition for production
        ? `https://e.${signupDomain}`
        : formData["region"].toLowerCase() == "in" //in(india) condition for production
        ? `https://in.${signupDomain}`
        : formData["region"].toLowerCase() == "au" //au(australia) condition for production
        ? `https://au.${signupDomain}`
        : `https://us1.${signupDomain}`;

    // console.log("signupURL", signupURL);

    await axios
      .post(`${signupURL}signup`, payload, { withCredentials: true })
      .then(response => {
        if (
          response.data.status === 200 ||
          response.data.response === "success"
        ) {
          localStorage.setItem(
            "appURLs",
            JSON.stringify(response.data.data.app_urls)
          );
          const searchParam = window.location.search;

          if (searchParam.includes("app/intercom")) {
            const code = searchParam.split("?");
            window.location = `${window.location.origin}/verifytoken/${
              response.data.data.token
            }?${code[code.length - 1]}`;
          } else if (searchParam.includes("webex")) {
            window.location = `${window.location.origin}/webex/verifytoken/${response.data.data.token}`;
          } else {
            window.location = `${window.location.origin}/verifytoken/${response.data.data.token}?region=${formData["region"]}`;
          }

          window.sessionStorage.setItem("navigatedViaHeader", false);
          this.setState({
            isSignup: false
          });
        } else {
          this.setState({
            isSignup: false
          });
          self.showSignupError();
          console.log("Something went wrong at API, response is=>", response);
        }
      })
      .catch(function(error) {
        self.setState({
          isSignup: false
        });
        if (error.response) {
          console.log("Error", error, error.response);
          self.showSignupError();
        } else if (error.request) {
          self.showSignupError();
        } else {
          self.showSignupError();
          console.log("Error", error, error.message);
        }
      });
  };

  reqForgotpasswordApi = () => {
    const { forgotFormData } = this.state;

    var payload = { ...forgotFormData };

    axios
      .post(
        `${this.state.appURLs.API_URL}/api/v1/common/forgotpassword`,
        payload
      )
      .then(function(response) {
        if (
          response.data.status === 200 ||
          response.data.response === "success"
        ) {
          self.setState({ forgotSuccess: true });
        } else {
          self.showForgotError();
        }
      })
      .catch(function(error) {
        if (error.response) {
          self.showForgotError();
        } else if (error.request) {
          self.showForgotError();
        } else {
          console.log("Error", error.message);
        }
      });
  };

  render() {
    const {
      isLoggedInCheck,
      errors,
      forgotFormerrors: forgotFormErrors,
      formSubmitted,
      forgotFormSubmitted,
      loginError,
      isLoading,
      emailError,
      downLoadError,
      showLoginForm,
      showSsoLoginForm,
      showLoginButton,
      showNextButton,
      showForgotForm,
      showSignupForm,
      onboardingPage,
      signupFormSubmitted,
      rememberMe,
      formData,
      forgotError,
      forgotSuccess,
      forgotFormData,
      usersLimitError,
      loginStore: { sso, loginType },
      isSsoExist,
      socialLoginEmailNotFound,
      accountBlockError,
      isAccountBlocked
    } = this.state;

    if (this.state.loading || !isLoggedInCheck) {
      return <div>Loading..</div>;
    } else {
      return (
        <section
          className={`login-page--redesign whole_bg ${
            onboardingPage ? "blue-bg" : ""
          } `}
        >
          {!onboardingPage && (
            <div className="zonkaIcon text-center">
              <img src={require("../../images/logo.svg")} alt="zonka" />
            </div>
          )}

          {usersLimitError && (
            <ShowNotification
              closeError={this.closeLoginError}
              errorHeading={`Users Limit!`}
              errorDesc={`Please check with your account admin.`}
            />
          )}
          {socialLoginEmailNotFound && (
            <ShowNotification
              closeError={this.closeSocialLoginEmailNotFoundError}
              errorHeading={`Account Not Found`}
              errorDesc={`No account found with the provided email.`}
            />
          )}

          {/* login form */}
          <LoginForm
            showLoginForm={showLoginForm}
            showSsoLoginForm={showSsoLoginForm}
            showLoginButton={showLoginButton}
            showNextButton={showNextButton}
            loginError={loginError}
            isLoading={isLoading}
            emailError={emailError}
            accountBlockError={accountBlockError}
            closeLoginError={this.closeLoginError}
            downLoadError={downLoadError}
            closeDownloadError={this.closeDownloadError}
            handleNextButton={this.handleNextButton}
            handleChangeEmail={this.handleChangeEmail}
            loginType={loginType}
            login={this.login}
            formSubmitted={formSubmitted}
            errors={errors}
            showForm={this.showForm}
            handleInputChange={this.handleInputChange}
            handleCheck={this.handleCheck}
            rememberMe={rememberMe}
            sso={sso}
            ssoLogin={this.ssoLogin}
            onSocialLogin={this.onSocialLogin}
          />

          {/* sso login form */}
          <SsoLoginForm
            closeSsoError={this.closeSsoError}
            isSsoExist={isSsoExist}
            showSsoLoginForm={showSsoLoginForm}
            showLoginButton={showLoginButton}
            showNextButton={showNextButton}
            loginError={loginError}
            isLoading={isLoading}
            emailError={emailError}
            closeLoginError={this.closeLoginError}
            downLoadError={downLoadError}
            accountBlockError={accountBlockError}
            isAccountBlocked={isAccountBlocked}
            closeDownloadError={this.closeDownloadError}
            handleNextButton={this.handleNextButton}
            handleChangeEmail={this.handleChangeEmail}
            loginType={loginType}
            login={this.login}
            formSubmitted={formSubmitted}
            errors={errors}
            showForm={this.showForm}
            handleInputChange={this.handleInputChange}
            handleCheck={this.handleCheck}
            rememberMe={rememberMe}
            sso={sso}
            ssoLogin={this.ssoLogin}
            onSocialLogin={this.onSocialLogin}
          />

          {/* forgot password form */}
          <ForgotPassword
            showForgotForm={showForgotForm}
            forgotSuccess={forgotSuccess}
            forgotError={forgotError}
            closeForgotError={this.closeForgotError}
            forgotPassword={this.forgotpassword}
            forgotFormSubmitted={forgotFormSubmitted}
            forgotFormErrors={forgotFormErrors}
            handleForgotInputChange={this.handleForgotInputChange}
            forgotFormData={forgotFormData}
            showForm={this.showForm}
          />

          {/* signup form */}
          <SignupForm
            showSignupForm={showSignupForm}
            formData={formData}
            signup={this.signup}
            signupFormSubmitted={signupFormSubmitted}
            errors={errors}
            handleSignupForm={this.handleSignupForm}
            isSignup={this.isSignup}
            showForm={this.showForm}
            onSocialLogin={this.onSocialLogin}
            onSocialSignup={this.onSocialSignup}
          />
          {/* onboarding page */}
          {onboardingPage && <WebexOnboardingPage showForm={this.showForm} />}
        </section>
      );
    }
  }
}

export default Login;



// WEBPACK FOOTER //
// ./src/components/Login/Login.js